import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { map } from "ramda";
import { css } from "./Theme";
import Global from "./Global";
import Editor from "./Editor";
import Flex from "./Flex";
import Canvas from "./Canvas";
import String from "./PropertyString";
import SelectString from "./PropertySelectString";
import Boolean from "./PropertyBoolean";
import Number from "./PropertyNumber";
import Box from "./Box";
import useProp from "../hooks/useProp";
import { DocumentState } from "./DocumentProvider";

const generateForm = components => {
  // TODO: Create an API for custom editor components
  // TODO: Pass the value from the global context to the component:
  // the component should render the value rather than setting internal state
  const groupSections = () => {
    // Map through each element in the array
    map(i => {}, components); // If there's a section prop, add them to a new data structure
    // Continue to update the data structure until mapped through the entire array
    // Return the new array that can then be rendered appropriatly

    /*
    [{
      name: "Document",
      properties: [{ ...props }]
    }, {
      name: "",
      properties: [{ ...props }]
    }]
    */
  };

  return map(i => {
    if (i.show) {
      switch (i.type) {
        case "number":
          return ___EmotionJSX(Number, _extends({
            onChange: num => i.setComponentState(num),
            key: i.id,
            value: i.value
          }, i));

        case "string":
          return ___EmotionJSX(String, _extends({
            onChange: string => i.setComponentState(string),
            key: i.id,
            value: i.value
          }, i));

        case "select":
          return ___EmotionJSX(SelectString, _extends({
            onChange: string => i.setComponentState(string),
            key: i.id,
            value: i.value
          }, i));

        case "boolean":
          return ___EmotionJSX(Boolean, _extends({
            onChange: bool => i.setComponentState(bool),
            key: i.id,
            value: i.value
          }, i));
      }
    }
  }, components);
};

const DocumentInternals = props => {
  const ctx = React.useContext(DocumentState);
  const [showEditor] = useProp({
    name: "showEditor",
    type: "boolean",
    show: false,
    value: false
  });
  const containerStyles = css({
    background: "background.primary",
    width: "100%",
    height: "100%"
  });
  const contentStyles = css({
    flexDirection: "row",
    width: "100%",
    height: "100%"
  });
  return ___EmotionJSX(Box, {
    css: containerStyles
  }, ___EmotionJSX(Global, null), ___EmotionJSX(Flex, {
    css: contentStyles
  }, ___EmotionJSX(Canvas, null, props.children), showEditor && ___EmotionJSX(Editor, null, generateForm(ctx))));
};

export default DocumentInternals;